import { PlaceholderExtension } from './placeholder.extension'

export * from './placeholder.extension'

export default PlaceholderExtension